<template>
  <v-container class="page" fluid>
    <v-row class="text-center" >
      <Loading v-if="loading" style="width: 50%;"></Loading>
      <v-col no-gutters v-else>
        <v-container fluid :style="!$vuetify.breakpoint.smAndDown ? 'margin-left: 2cm; margin-top: 2cm;' : 'margin-left: auto; margin-top: 2cm;'">
          <h1>Hey, <br/> Welcome Back 👋🏿 </h1>
          <br/> <br/>
          <v-row justify="center">
            <v-col md="7" align="center">
              <validation-observer ref="observer">
                <validation-provider
                  rules="email|required"
                  v-slot="{ errors }">
                      <v-text-field
                      filled
                      prepend-inner-icon="mdi-email"
                      placeholder="  Email Address"
                      autocomplete="off"
                      type="email" 
                      name="username" 
                      id="email"
                      v-model="form.username"
                      :class="(errors[0]) ? 'input-error' : ''"
                      ></v-text-field>
                      <span class="input-error-text">{{ errors[0] }}</span>
                  </validation-provider>
                  <validation-provider
                  rules="required"
                  v-slot="{ errors }">
                      <v-text-field
                      filled
                      prepend-inner-icon="mdi-lock"
                      placeholder="  Password"
                      autocomplete="off"
                      name="password" 
                      id="password"
                      v-model="form.password"
                      :type="show ? 'text' : 'password'" 
                      :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                      :class="(errors[0]) ? 'input-error' : ''"
                      @click:append="show = !show"
                      ></v-text-field>
                      <span class="input-error-text">{{ errors[0] }}</span>
                  </validation-provider>
              </validation-observer>
            </v-col>
          </v-row>
          <v-row justify="center" style="margin-top: -0.6cm;">
            <v-col md="7" align="center">
              <v-btn 
              block
              style="background-color: #4BB27C; color: white; border-radius: 30px;" 
              height="60"
              @click="logIn()"> LOGIN </v-btn>
              <br/> <br/>
              <router-link to="/forgot" class="forgot">Forgot password?</router-link>
              <br/> <br/> <br/> <br/> <br/>
              <span class="login-signup-change">Don't have an account? <router-link to="/signup" style="color: #4BB27C; text-decoration: none;"> Sign Up </router-link> </span>
            </v-col>
          </v-row>
          <span v-for="(error, idx) of errors" :key="idx" class="error-block">{{ error }}</span>
        </v-container>
      </v-col>
      <v-col v-if="!$vuetify.breakpoint.smAndDown" no-gutters cols="6">
        <v-img cover src="@/assets/driver.png" height="100vh" width="100%" style="margin-top: -1cm;"></v-img>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { email, required } from 'vee-validate/dist/rules';
import Loading from "@/components/Loading.vue"

extend('email', {
    ...email,
    message: 'Invalid email'
})

extend('required', {
    ...required,
    message: 'This field is required.'
}); 

export default {
  name: 'Login',
  components: {
    ValidationObserver,
    ValidationProvider,
    Loading
  },
  props: {
    emailAddress: String,
    password: String
  },
  data() {
    return {
      form: {
        username: '',
        password: '',
      },
      errors: [],
      show: false
    }
  },
  computed: {
    loading() {
      return this.$store.getters['auth/isLoading'];
    },
    isClient() {
      return this.$store.getters['auth/isClient'];
    },
    isDriver() {
      return this.$store.getters['auth/isDriver'];
    },
    isAdmin() {
      return this.$store.getters['auth/isAdmin'];
    },
    loggedIn() {
      return this.$store.getters['auth/isLoggedIn'];
    },
    loginError() {
      return this.$store.getters['auth/getLoginError'];
    }
  },
  watch: {
    loggedIn(isLoggedIn) {
      if (isLoggedIn) {
        this.completeLogin();
      }
    },
    loginError(newError) {
      alert('Email or Password incorrect');
      console.log(newError);
    }
  },
  methods: {
    async logIn() {
      if (await this.$refs['observer'].validate()) {
        await this.$store.dispatch('auth/login', { username: this.form.username, password: this.form.password } );
        this.errors = []
      }
    },
    completeLogin() {
      if (this.isAdmin){
        this.$router.push('/dashboard/adminBookings');
      }
      if (this.isDriver){
        this.$router.push('/dashboard/driverBookings');
      }
      if (this.isClient){
        this.$router.push('/dashboard/bookings');
      }
    }
  },
  async mounted(){
    this.form.username = this.emailAddress;
    this.form.password = atob(this.password);
    if(this.form.username != '' && this.form.password != ''){
      await this.$store.dispatch('auth/login', { username: this.form.username, password: this.form.password } ); //automatically login users
    }
  }
}
</script>

<style lang="scss" scoped src="@/scss/auth.scss"></style>